module.exports = __webpack_public_path__ + "static/media/Bicycles_Thumb_1.7e79eae8.jpg";